export const BREAKPOINT = {
  XS: 480,
  SM: 768,
  MD: 992,
  LG: 1200
};

export const KEYCODE = {
  ENTER: 13,
  SHIFT: 15,
  ESC: 27,
  SPACE: 32,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40
};
